declare module "@mui/material/styles/createPalette" {
  interface GradientsPaletteOptions {
    primary: string;
    info: string;
    title: string;
    bannerBgColor: string;
    bannerTitle: string;
  }

  interface Palette {
    gradients: GradientsPaletteOptions;
  }

  interface PaletteOptions {
    gradients: GradientsPaletteOptions;
  }
}

const GRADIENTS = {
  primary: "linear-gradient(180deg, #ADACAC 0%, #DCDCDC 47.92%, #AEAEAE 100%)",
  info: "linear-gradient( 180deg, #C89C00 0%, #FFDA56 49.99%, #C89C00 100%)",
  title: "linear-gradient(to top, #D9D9D9 0%, #D9D9D9 100%)",
  bannerBgColor: "linear-gradient(180deg, #00216C 0%, #123C9B 49.48%, #00216C 100%)",
  bannerTitle:
    "linear-gradient(180deg, #C4A73F 0%, #FFFBD4 25%, #F8F0C2 30.00%, #E7D595 41.00%, #CBAA4E 55.00%, #C29C36 60.00%, #ECDD91 86.00%, #EFE196 87.00%, #FFFBD4 100%)",
};

declare module "@mui/material/styles/createPalette" {
  interface PaletteColor {
    lighter: string;
    darker: string;
  }
}

const common = {
  common: { black: "#000000", white: "#ffffff" },
  primary: {
    lighter: "#00F",
    light: "#FF2133",
    main: "#E60012",
    dark: "#E60013",
    darker: "#DE032B",
  },
  secondary: {
    lighter: "#F00",
    light: "#FF0000",
    main: "#23316B",
    dark: "#9d201e",
  },
  error: {
    main: "#FF0000",
  },
  grey: {
    "100": "#EBEBEB",
    "200": "#CBCBCB",
    "300": "#9FA3B6",
    "400": "#808080",
    "500": "#9FA3B6",
    "600": "#707070",
    "700": "#4E4E4E",
    "800": "#B1B1B1",
    "900": "#6c6c6c",
  },
  info: {
    light: "#23316B",
    main: "#F2F5FF",
    lighter: "#E5E5E5",
    darker: "#707070",
  },
  background: {
    default: "#F2F5FF",
  },
  gradients: GRADIENTS,
};

const palette = { ...common };

export default palette;
